import React from 'react'
import _Helper from '../_Helper';

// export default class Rupee extends React.Component {
//     constructor(props) {
//         super(props)
//         this.amount = _Helper.commalize(props.amount);
//         // this.state = {
//         //     amount: amount,
//         // }
//     }
//     render() {
//         return <React.Fragment>&#8377; {this.amount}</React.Fragment>
//     }
// }

const Rupee = ({amount}) =>(
    <React.Fragment>&#8377; {_Helper.commalize(amount)}</React.Fragment>
)
export default Rupee;